interface PasswordStrengthIndicatorProps {
  password: string
}

const calculateStrength = (password: string): number => {
  let strength = 0

  // 길이 체크
  if (password.length >= 6) strength++
  if (password.length >= 8) strength++

  // 대소문자 혼합
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strength++

  // 숫자 포함
  if (/\d/.test(password)) strength++

  // 특수문자 포함
  if (/[^a-zA-Z0-9]/.test(password)) strength++

  // 최대 4단계
  return Math.min(strength, 4)
}

export function PasswordStrengthIndicator({ password }: PasswordStrengthIndicatorProps) {
  const strength = calculateStrength(password)
  const colors = ['bg-red-500', 'bg-orange-500', 'bg-yellow-500', 'bg-green-500']
  const labels = ['약함', '보통', '양호', '강력']

  if (!password) {
    return null
  }

  return (
    <div className="mt-2">
      <div className="flex gap-1 mb-1">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded transition-colors ${
              i < strength ? colors[strength - 1] : 'bg-gray-200'
            }`}
          />
        ))}
      </div>
      {strength > 0 && (
        <p className="text-xs text-gray-600">
          비밀번호 강도: <span className="font-medium">{labels[strength - 1]}</span>
        </p>
      )}
    </div>
  )
}
